<template>
  <div class="container-fluid" style="background-image: url('./Image/back.jpg'); background-size: cover; height: 100vh">
    <loading v-if="loadingRender"></loading>
    <!-- <loading v-if="loadingRender"></loading>  -->
    <div class="row">
      <div class="col-md-2"></div>
      <div class="col-md-8 mt-md-5 p-md-5">
        <net-pa-card :Classes="'bg-dark-Custom'">
          <template slot="header">
            <h6 class="text-right">
              <i class="fas fa-cloud-download-alt ml-2"></i>واریز به حساب / پرداخت اقساط از طریق شماره حساب / تسهیلات یا شناسه واریز بدون ورود به سامانه
              <span class="float-left" @click="$router.go(-1)"> <i data-v-9331d9a2="" title="بازگشت به صفحه قبلی" class="fas fa-arrow-left text-light Pointer" style="float: left; font-size: 18px"></i></span>
            </h6>
          </template>
          <template slot="content">
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <form id="div1" class="text-center w-100">
                    <div class="row">
                      <div class="col-md-5 col-12">
                        <div class="border-bottom border-warning pb-2">
                          <b style="font-size: 15px !important" class="text-dark">اطلاعات حساب</b>
                        </div>
                        <div>
                          <!-- <select class="form-control mt-2 text-center Pointer" id="SelectNoeVarizi"
                            @change="EmptyResult()" v-model="DepositType" style="max-height: 100px !important">
                            <option selected :value="null">
                              انتخاب نوع واریز
                            </option>
                            <option class="Pointer" :value="1">
                              واریز با شناسه واریز
                            </option>
                            <option class="Pointer" :value="2">
                              واریز با شماره حساب | تسهیلات
                            </option>
                          </select> -->

                          <div class="form-check text-right mt-3" v-if="!IsQuery">
                            <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" checked @click="getDepositType(1)" />
                            <label class="form-check-label mx-4" for="flexRadioDefault1"> واریز با شناسه واریز حساب | تسهیلات </label>
                          </div>
                          <div class="form-check text-right mt-2" v-if="!IsQuery">
                            <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" @click="getDepositType(2)" />
                            <label class="form-check-label mx-4" for="flexRadioDefault2"> واریز با شماره حساب | تسهیلات </label>
                          </div>
                          <div class="form-check text-right mt-2" v-if="!IsQuery">
                            <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault3" @click="getDepositType(3)" />
                            <label class="form-check-label mx-4" for="flexRadioDefault3"> واریز با شماره مشتری / کدملی <span class="fas fa-info-circle text-primary Pointer" title="[ بدون وارد کردن کد شعبه ]"></span> </label>
                          </div>
                          <div v-if="DepositType == 1 && !IsQuery" class="mt-2 row text-center">
                            <div class="col-9">
                              <input autocomplete="off" class="form-control text-center" id="Shenase" type="number" placeholder="شناسه واریز" v-model="Shenase" v-mask="'####################'" />
                            </div>
                            <div class="col-3 pr-0">
                              <button type="button" @click="CheckupShenase()" class="btn btn-outline-dark rounded" style="font-size: 14px !important" dir="ltr">بررسی</button>
                            </div>
                          </div>
                          <div v-if="DepositType == 2" class="mt-2 row text-center">
                            <div class="col-9">
                              <input autocomplete="off" class="form-control text-center" dir="ltr" id="VCode" type="text" placeholder="شماره حساب | تسهیلات" v-model="VCode" v-mask="'###-##-##########'" />
                            </div>
                            <div class="col-3 pr-0">
                              <button type="button" @click="CheckupVcode()" class="btn btn-outline-orange rounded" style="font-size: 14px !important" dir="ltr">بررسی</button>
                            </div>
                          </div>
                          <div v-if="DepositType == 3" class="mt-2 row text-center">
                            <div class="col-9">
                              <input autocomplete="off" class="form-control text-center" dir="ltr" id="ShenaseOzve" type="text" placeholder=" شماره مشتری / کدملی" v-model="ShenaseOzv" v-mask="'##########'" />
                            </div>
                            <div class="col-3 pr-0">
                              <button type="button" @click="CheckupShenaseOzve()" class="btn btn-outline-orange rounded" style="font-size: 14px !important" dir="ltr">بررسی</button>
                            </div>
                          </div>
                          <!-- {{ListModel}} -->
                          <select v-if="DepositType == 3 && IsLoad" class="form-control mt-2 text-center Pointer" id="SelectNoeVarizi" style="max-height: 100px !important" @change="Resultradio3()" v-model="Resultcmb">
                            <option :value="-1">-- انتخاب حساب | تسهیلات --</option>
                            <option v-for="item in this.ListModel" :key="item.id" :value="item">
                              <span>{{ item.vCode }}</span> <span>{{ item.desNoe }}</span>
                            </option>
                          </select>
                          <div v-if="DepositType == 2 || DepositType == 1 || DepositType == 3" class="mt-2 row text-center">
                            <div v-if="Result != null" class="col-12 mb-2 font-weight-bold">
                              <span class="text-secondary"> مشخصات :</span>
                              <span class="text-dark mr-2">{{ Result != null ? Result.nameFamily : '' }}</span>
                              <span class="mr-2">_</span>
                              <span class="text-dark mr-2" dir="ltr">{{ Result != null ? Result.desNoe : '' }}</span>
                              <span v-if="Result.tblSarfaslTypeId == 1" class="mr-2">_ سررسید قسط </span>
                              <span class="text-danger mr-2" dir="ltr">{{ Result != null ? Result.minTarGhestBedehkar : '' }}</span>
                              <!-- <div class="text-dark mr-2" dir="ltr">{{Result!=null?Result.vCode:""}}</div> -->
                            </div>
                            <div class="col-12">
                              <input class="form-control text-center 3ragham" id="Mab" :disabled="FixVariz" v-model="Mablagh" dir="rtl" @keyup="$PutCommatoInput()" @keypress="$ValidNumber($event, 11)" type="text" placeholder="مبلغ واریزی" style="font-size: 18px !important" />
                            </div>
                            <!-- <div class="col-12 mt-2">
                              <input class="form-control text-center required" dir="ltr" type="number"
                                @keypress="$ValidNumber($event, 11)" placeholder="شماره تلفن" v-model="Mobile" />
                            </div> -->
                          </div>
                        </div>
                        <div class="border-bottom border-warning pb-2 mt-3">
                          <b style="font-size: 15px !important" class="text-dark">اطلاعات واریز کننده</b>
                        </div>
                        <div>
                          <div class="mt-2 row text-center">
                            <div class="col-12">
                              <input class="form-control text-center required" type="text" placeholder="نام و نام خانوادگی" v-model="NameFamily" />
                            </div>
                            <div class="col-12 mt-2 mb-3">
                              <input class="form-control text-center required" dir="ltr" type="number" @keypress="$ValidNumber($event, 11)" placeholder="شماره تلفن" v-model="Mobile" />
                            </div>
                            <div class="col-12 mt-2">
                              <textarea class="form-control text-center" type="text" placeholder="توضیحات" maxlength="300" rows="3" v-model="Description"></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-7 col-12">
                        <payment @GatewayCode="Get_GatewayCode" @FixVarizGhestHasJarime="FixVarizGhestHasJarime" @FixVarizGhest="FixVarizGhest" v-if="wwwtblShobeid!=null" :wwwtblShobeid="wwwtblShobeid">
                          <template v-slot:ContentButtonPayment>
                            <button id="BtnPayment" class="btn w-50" :class="Result == null || Number(Mablagh.replace(/,/g, '')) < 10000 ? 'btn-secondary' : 'btn-success'" :disabled="Result == null || Number(Mablagh.replace(/,/g, '')) < 10000" @click.prevent="Payment">
                              واریز
                              {{ $Comma3ragham(Mablagh.replace(/,/g, '')) }}
                            </button>
                            <div id="AletSumMab" class="alert alert-info w-100 font-weight-bold d-none">تسهیلات انتخابی شما تسویه شده ،برای اطمینان بیشتر از داخل پنل کاربری خود در سامانه از بخش لیست تسهیلات وضعیت تسهیلات خودرا مشاهده کنید</div>
                          </template>
                        </payment>
                        <div class="alert alert-warning" v-else>
                          کاربر گرامی جهت ادامه مراحل واریز | پرداخت  لطفا یکی از سه روش سمت راست را انتخاب و پس از کلیک برروی دکمه بررسی میتوانید به  ادامه مراحل بپردازید
                        </div>
                      </div>
                      <!-- <div>
                        <button class="btn btn-danger" @click.prevent="gotonoti()">TEST</button>
                      </div> -->
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </template>
        </net-pa-card>
      </div>
      <div class="col-md-2"></div>
    </div>
  </div>
</template>
<script>
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
import Payment from './Payment.vue'
import loading from '../Tools/NetPa/Loading.vue'
// import loading from '../Tools/NetPa/Loading.vue'
// import VueRecaptchaEh from "vue-recaptcha-eh";
export default {
  components: {
    NetPaCard,
    Payment,
    loading,
  },
  data() {
    return {
      DataAxios_cmbTaahodat: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'TaahodatByShenas',
        Token: '',
      },
      Resultcmb: -1,
      ShenaseOzv: null,
      ListModel: null,
      IsLoad: false,
      DepositType: 1,
      Shenase: '',
      VCode: '',
      Mablagh: '',
      NameFamily: '',
      Mobile: '',
      Description: '',
      Result: null,
      GatewayCode: null,
      DataAxiosRow: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'TaahodatByShenaseVariz',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxiosRowVCode: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'TaahodatByVC',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxios_Variz: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'VarizGorohi/SetVarizGorohi',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxiosRowGetShenase: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat/GetShenaseVariz',
        Token: this.$session.get('TokenNetPa'),
      },
      FixVariz: false,
      loadingRender: false,
      MabFormulaJarime: 0,
      CheckUpMablagh: null,
      IsQuery: false,
      IsLinkPay: false,
      wwwtblShobeid:null
    }
  },
  methods: {
    CheckupShenaseOzve() {
      if (this.ShenaseOzv != '') {
        this.loadingRender = true
        const formData = new FormData()
        // var convertShenase=this.ShenaseOzv.toString().substring(0,this.ShenaseOzv.toString().length-2)
        formData.append('Shenase', this.ShenaseOzv)
        this.DataAxios_cmbTaahodat.ArryfildValue = formData
        this.$PostFormData(this.DataAxios_cmbTaahodat).then((data) => {
          if (data.length != 0) {
            // console.log(data);
            this.IsLoad = true
            if (this.$session.get('CustCode') == 255) {
              this.ListModel = data.filter((x) => x.tblsarfasltypeid != 6)
            } else {
              this.ListModel = data
            }
            this.loadingRender = false
          } else {
            this.$mySweetDefaultTost('خطا', 'شناسه مشتری وارد شده صحیح نمی باشد .', 'error', 2500)
            this.loadingRender = false
          }
          // this.Resultcmb = data[0]
        })
      } else {
        this.$mySweetDefault('خطا', 'شناسه مشتری نمی تواند خالی می باشد ', 'error', 2500)
      }
    },
    getDepositType(val) {
      this.DepositType = val
      this.Result = null
      // if(val==3){

      // }
    },
    gotonoti() {
      const notification = {
        title: 'تیکت جدید',
        options: {
          body: 'خطا در نرم افزار .....',
          icon: './img/icons/favicon.ico',
          silent: true,
        },
        events: {
          onerror: function () {},
          onclick: function () {
            alert('ok')
          },
          onclose: function () {},
          onshow: function () {},
        },
      }
      this.$notification.show(notification.title, notification.options, notification.events)
    },
    CheckupShenase() {
      if (this.Shenase != '') {
        this.loadingRender = true
        this.VCode = ''
        const formData = new FormData()
        formData.append('ShenaseVariz', this.Shenase)
        this.DataAxiosRow.ArryfildValue = formData

        this.$PostFormData(this.DataAxiosRow).then((data) => {
          if (data.state == 'Success') {
            this.loadingRender = false
            this.Result = data.result
            this.wwwtblShobeid=this.Result.wwwtblShobeid
            if (data.result.tblSarfaslTypeId != 1) {
              this.FixVariz = false
            }
            if (data.result.mande + data.result.wwwJarime - data.result.sumMabTaeedNaShode <= 0 && data.result.tblSarfaslTypeId == 1) {
              document.getElementById('Mab').classList.add('d-none')
              document.getElementById('BtnPayment').classList.add('d-none')

              document.getElementById('AletSumMab').classList.remove('d-none')
            } else {
              document.getElementById('Mab').classList.remove('d-none')
              document.getElementById('BtnPayment').classList.remove('d-none')

              document.getElementById('AletSumMab').classList.add('d-none')
            }

            if (data.result.mablaghGhestVam > 0) {
              this.Mablagh = this.$Comma3ragham(data.result.sumGhabelPar)
              this.CheckUpMablagh = data.result.sumGhabelPar
            } else {
              this.Mablagh = ''
            }
            this.loadingRender = false
          } else {
            if (this.$route.query.sh) {
              if (Number(this.$route.query.sh) > 0 && this.$route.query.sh != null) {
                this.$mySweetDefaultTost('خطا', 'شناسه واریز موجود در لینک صحیح نمیباشد.', 'error', 5000)
                this.$router.push({ name: 'LoginPage' })
              }
            } else this.$mySweetDefaultTost('خطا', 'شناسه وارد شده صحیح نمی باشد .', 'error', 2500)
            this.Result = null
            this.loadingRender = false
          }
        })
      } else {
        this.$mySweetDefault('خطا', 'شناسه واریز خالی می باشد ', 'error', 2500)
        this.Result = null
      }
    },
    CheckupVcode() {
      if (this.VCode != '') {
        this.loadingRender = true
        this.Shenase = ''
        const formData = new FormData()
        formData.append('VCode', this.VCode)
        this.DataAxiosRowVCode.ArryfildValue = formData

        this.$PostFormData(this.DataAxiosRowVCode).then((data) => {
          if (data != null) {
            this.Result = data
            this.loadingRender = false
            this.wwwtblShobeid=this.Result.wwwtblShobeid
            //console.log('😎 ~ this.$PostFormData ~ data:', data)
            if (data.mande + data.wwwJarime - data.sumMabTaeedNaShode <= 0 && data.tblSarfaslTypeId == 1) {
              document.getElementById('Mab').classList.add('d-none')
              document.getElementById('BtnPayment').classList.add('d-none')

              document.getElementById('AletSumMab').classList.remove('d-none')
            } else {
              document.getElementById('Mab').classList.remove('d-none')
              document.getElementById('BtnPayment').classList.remove('d-none')

              document.getElementById('AletSumMab').classList.add('d-none')
            }
            if (data.sumGhabelPar > 0) {
              this.Mablagh = this.$Comma3ragham(data.sumGhabelPar)
            }
            if (data.mablaghGhestVam > 0) {
              this.Mablagh = this.$Comma3ragham(data.sumGhabelPar)
              this.CheckUpMablagh = data.sumGhabelPar
            }
            // else {
            //   this.Mablagh = ''
            // }
          } else {
            this.$mySweetDefaultTost('خطا', 'شماره حساب وارد شده صحیح نمی باشد .', 'error', 2500)
            this.Result = null
            this.loadingRender = false
          }
        })
      } else {
        this.$mySweetDefault('خطا', 'شماره حساب نمی تواند خالی می باشد ', 'error', 2500)
        this.Result = null
      }
    },
    CheckupVcodeByShenase(vcode) {
      if (vcode != '') {
        this.loadingRender = true
        this.Shenase = ''
        const formData = new FormData()
        formData.append('VCode', vcode)
        this.DataAxiosRowVCode.ArryfildValue = formData

        this.$PostFormData(this.DataAxiosRowVCode).then((data) => {
          // console.log("😂 ~ data:", data)
          if (data != null) {
            this.loadingRender = false
            this.wwwtblShobeid=data.wwwtblShobeid
            // console.log('*/*/*/*/',data);
            this.Result = data
            if (data.mande + data.wwwJarime - data.sumMabTaeedNaShode <= 0 && data.tblSarfaslTypeId == 1) {
              document.getElementById('Mab').classList.add('d-none')
              document.getElementById('BtnPayment').classList.add('d-none')

              document.getElementById('AletSumMab').classList.remove('d-none')
            } else {
              document.getElementById('Mab').classList.remove('d-none')
              document.getElementById('BtnPayment').classList.remove('d-none')

              document.getElementById('AletSumMab').classList.add('d-none')
            }
            if (data.mablaghGhestVam > 0) {
              this.Mablagh = this.$Comma3ragham(data.sumGhabelPar)
              this.CheckUpMablagh = data.sumGhabelPar
            } else if (data.sumGhabelPar > 0) {
              this.Mablagh = this.$Comma3ragham(data.sumGhabelPar)
              this.CheckUpMablagh = data.sumGhabelPar
            } else {
              this.Mablagh = ''
            }
            this.loadingRender = false
          } else {
            this.$mySweetDefaultTost('خطا', 'شماره حساب وارد شده صحیح نمی باشد .', 'error', 2500)
            this.Result = null
            this.loadingRender = false
          }
        })
      } else {
        this.$mySweetDefault('خطا', 'شماره حساب نمی تواند خالی می باشد ', 'error', 2500)
        this.Result = null
      }
    },
    Payment() {
      if (this.$ValidForm('div1')) {
        if (this.Result.tblSarfaslTypeId != 1) {
          this.SendPayment()
        } else {
          if (this.Result.sumGhabelPar || this.Result.sumGhabelPar != null) {
            if (Number(this.Mablagh.replace(/,/g, '')) > this.Result.mande + this.Result.wwwJarime - this.Result.sumMabTaeedNaShode) {
              this.$mySweetDefault('هشدار', 'مبلغ پرداختی نمی تواند بیشتر از مانده تسهیلات باشد . ', 'warning', 2500)
            } else {
              this.FormulaJarime()
            }
          } else {
            this.$mySweetDefault('خطا', 'تسهیلات انتخابی شما تسویه شده ،برای اطمینان بیشتر از داخل پنل کاربری خود در سامانه از بخش لیست تسهیلات وضعیت تسهیلات خودرا مشاهده کنید', 'error', 2500)
          }
        }
      }
    },
    Get_GatewayCode(val) {
      this.GatewayCode = val
    },
    GetShenase(Vcode) {
      const formData = new FormData()
      formData.append('Vcode', Vcode)
      this.DataAxiosRowGetShenase.ArryfildValue = formData
      this.$PostFormData(this.DataAxiosRowGetShenase).then((data) => {
        return data
      })
    },
    Resultradio3() {
      // console.log(this.Resultcmb);
      if (this.Resultcmb != -1) {
        this.CheckupVcodeByShenase(this.Resultcmb.vCode)
      }
    },
    FixVarizGhest(val) {
      this.FixVariz = val
      if (this.Result.tblSarfaslTypeId != 1 && this.Result.sumGhabelPar == 0) {
        this.FixVariz = false
      }
    },
    FixVarizGhestHasJarime(val) {
      var jarime=this.Result.wwwJarime
      if (jarime>0 ) {
        this.FixVariz = val
      }
    },
    SendPayment() {

      this.Mablagh = this.Mablagh.replace(/,/g, '')
      const WwwtblVarizGorohiRiz = []
      WwwtblVarizGorohiRiz.push({
        WwwtblTaahodatId: this.Result.id,
        Mablagh: Number(this.Mablagh.replace(/,/g, '')),
        SharhRiz: this.Description + this.Result.vCode,
        WwwtblAzaId: this.Result.wwwtblAzaId,
        BnpCashDBtblTaahodatId: this.Result.bnpCashDBtblTaahodatId,
        BnpCashDBtblAzaId: this.Result.bnpCashDBtblAzaId,
        MablaghJarime: Math.floor(this.MabFormulaJarime),
        TarixGhest: this.Result.minTarGhestBedehkar,
        IsTaahodatRiz: false,
      })

      this.DataAxios_Variz.ArryfildValue.Mablagh = Number(this.Mablagh.replace(/,/g, ''))
      this.DataAxios_Variz.ArryfildValue.CodeRahgiri = 0
      this.DataAxios_Variz.ArryfildValue.Tarix = this.$store.state.JalaliDate
      this.DataAxios_Variz.ArryfildValue.Sharh = ' واریز | پرداخت بدون ورود '
      this.DataAxios_Variz.ArryfildValue.ZamanInsert = this.$store.state.JalaliDate
      this.DataAxios_Variz.ArryfildValue.CustCode = Number(this.$session.get('CustCode'))
      this.DataAxios_Variz.ArryfildValue.tblComboIdVaziatGrp312 = 5538
      this.DataAxios_Variz.ArryfildValue.wwwtblAzaId = Number(this.Result.wwwtblAzaId)
      this.DataAxios_Variz.ArryfildValue.StatusVariz = 2
      this.DataAxios_Variz.ArryfildValue.WwwtblVarizGorohiRiz = WwwtblVarizGorohiRiz
      this.$PostData(this.DataAxios_Variz).then((result) => {
        if (result.status === 'Success') {
          this.$Payment(
            this.GatewayCode + '',
            this.Mablagh,
            this.NameFamily,
            '',
            this.Mobile,
            WwwtblVarizGorohiRiz[0].WwwtblTaahodatId,
            this.Shenase != null && this.Result != null ? this.Shenase + '' : this.GetShenase(this.VCode),
            this.Result.vCode,
            'واریز | پرداخت  بدون ورود',
            this.Result.wwwtblAzaId + '',
            this.$session.get('CustCode'),
            this.Result.wwwtblShobeid + '',
            result.idRepoMaster,
            this.Result.codeMeli.trim(),
            this.Result.nameFamily,
            this.Result.mobile,
            this.Result.codeMeli.trim(),
          )
        } else {
          this.$mySweetDefaultTost(' ', ' در پرداخت مشکلی پیش آمده لطفا مجددا تلاش فرمایید', 'warning', 4000)
          this.DeleteAllItemsCart()
        }
      })
    },
    FormulaJarime() {
      if (Number(this.Mablagh.replaceAll(/,/g, '')) < Number(this.CheckUpMablagh)) {
        var MablaghJarime = this.Result.wwwJarime == null ? 0 : this.Result.wwwJarime
        if (this.$session.get('CustCode') == 561){
          this.MabFormulaJarime = (Number(this.Mablagh.replaceAll(/,/g, '')) / (Number(this.CheckUpMablagh))) * MablaghJarime
        }
        else{
          this.MabFormulaJarime = (Number(this.Mablagh.replaceAll(/,/g, '')) / (Number(this.CheckUpMablagh) - MablaghJarime)) * MablaghJarime
        }
        this.SendPayment()
      } else {
        this.MabFormulaJarime = this.Result.wwwJarime == null ? 0 : this.Result.wwwJarime
        this.SendPayment()
      }
    },
    CheckupLinkPay() {
      if (this.$route.query.sh) {
        if (Number(this.$route.query.sh) > 0 && this.$route.query.sh != null) {
          if (this.IsLinkPay) {
            this.loadingRender = true
            this.IsQuery = true
            this.Shenase = Number(this.$route.query.sh)
            this.CheckupShenase()
          } else {
            this.$mySweetDefaultTost('خطا', 'سامانه واریز با لینک پرداخت برای شما فعال نگریدیده ، لطفا با مدیریت '+this.$session.get('IsTaavoniEtebar')==true?'تعاونی اعتبار':'صندوق'+' هماهنگ کنید', 'error', 8000)
            this.loadingRender = true
          }
        } else {
          this.IsQuery = false
        }
      } else {
        this.IsQuery = false
      }
    },
  },
  // updated() {
  //   if (document.getElementById("SelectNoeVarizi") === document.activeElement) {
  //     if (this.DepositType == 1) {
  //       document.getElementById("Shenase").focus();
  //     }
  //     if (this.DepositType == 2) {
  //       document.getElementById("VCode").focus();
  //     }
  //   }
  // },
  mounted() {
    if (!this.$session.get('CustCode')) {
      console.warn('MOUNTES')
      this.$router.push({ name: 'LoginPage' })
    }
  },
  created() {
    var axios = require('axios')
    var config = {
      method: 'GET',
      url: '/appSettings.json?nocache=123',
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
        'Content-Type': 'application/json',
      },
    }
    axios(config).then((result) => {
      // console.log(result.data)
      this.IsLinkPay = result.data.IsLinkPay
      this.CheckupLinkPay()
    })
  },
  
}
</script>
<style scoped>
.border-warning {
  border-bottom: 1px dashed #ff9800 !important;
}

.To {
  background-color: #3a3a4100;
  border: none;
  border-bottom: 2px solid #dca722;
  color: #dca722 !important;
  border-radius: 0px;
  width: 100%;
}
</style>
